import { formatClock, ROUND_SECONDS, type UsefulWindow } from "@69ly/shared";
import { useTranslation } from "react-i18next";

/** The round clock from 1:55 to 0:00, with the useful windows on it. */
export function WindowsBar({ windows }: { windows: UsefulWindow[] }) {
  const { t } = useTranslation();
  if (windows.length === 0) return <p className="muted small">{t("mapView.noWindows")}</p>;
  return (
    <div className="windows">
      <div className="windows-track" aria-hidden="true">
        {windows.map((w, i) => (
          <span
            key={i}
            className="windows-bar"
            style={{ left: `${((ROUND_SECONDS - w.from) / ROUND_SECONDS) * 100}%`, width: `${Math.max(((w.from - w.to) / ROUND_SECONDS) * 100, 1.5)}%` }}
          />
        ))}
      </div>
      <div className="windows-scale muted small" aria-hidden="true">
        <span>1:55</span>
        <span>0:00</span>
      </div>
      <ul className="windows-list">
        {windows.map((w, i) => (
          <li key={i}>
            <span className="mono">
              {formatClock(w.from)} → {formatClock(w.to)}
            </span>
            {w.label && <span className="muted"> · {w.label}</span>}
          </li>
        ))}
      </ul>
    </div>
  );
}
